import { render, staticRenderFns } from "./statusChange.vue?vue&type=template&id=259e0308&scoped=true&"
import script from "./statusChange.vue?vue&type=script&lang=js&"
export * from "./statusChange.vue?vue&type=script&lang=js&"
import style0 from "./statusChange.vue?vue&type=style&index=0&id=259e0308&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259e0308",
  null
  
)

export default component.exports